import { connect, MapStateToProps } from 'react-redux'
import E3DAppInitializer from './E3DAppInitializer'
import is3DExhibitionEnabledSelector from '../../../redux/selectors/feature-scope/is3DExhibitionEnabledSelector'
import { State } from '../../../redux/reducers/rootReducer'
import {isGrpLoggedInSelector, isGrpLoginLoadingSelector} from '../../../redux/selectors/e3DGrpAuthSelectors'

interface StateProps {
    is3DExhibitionEnabled: boolean
    isGrpLoading: boolean
    isGrpLoggedIn: boolean
}

const mapStateToProps: MapStateToProps<StateProps, {}, State> = (state) => ({
    is3DExhibitionEnabled: is3DExhibitionEnabledSelector(state),
    isGrpLoading: isGrpLoginLoadingSelector(state),
    isGrpLoggedIn: isGrpLoggedInSelector(state),
})

export default connect(mapStateToProps)(E3DAppInitializer)
